<template>
    <div>
        <usage
            v-if="handle === 'usage'"
            :title="entry.title"
            :body="entry.body"
            :steps="entry.steps"
            :asset="entry.asset"
        />
        <div
            v-else-if="handle === 'partners'"
            class="l-grid__row justify-center"
        >
            <div class="w-1/1 md:w-10/12">
                <partners
                    :title="entry.title"
                    :partners="entry.partners"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Usage from 'templates/components/Usage';
import Partners from 'templates/components/Partners';

export default {
    name: 'block-recurrent',
    components: {
        Usage,
        Partners,
    },
    props: {
        entry: {
            type: Object,
        },
        handle: {
            type: String,
        },
    },
};
</script>
